import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect, useRef } from "react";
import { useMutation } from "@apollo/client";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import BrowserPersistence from "@overrides_venia/peregrine/util/simplePersistence";
import { CREATE_OR_UPDATE_MEMBER_PARTNERSHIP_QRCODE } from "./partnershipQrcode.gql";
import { GET_CUSTOMER } from "@overrides_venia/peregrine/talons/SignIn/signIn.gql";
import { useAwaitQuery } from "@magento/peregrine/lib/hooks/useAwaitQuery";
var storage = new BrowserPersistence();
var QRCODE_STORAGE_KEY = "partnership_qrcode";
var QRCODE_TTL = 86400;
export var cleanupQrcodeFromUrl = (history, location) => {
  var urlParams = new URLSearchParams(location.search);
  if (urlParams.has("qrcode")) {
    urlParams.delete("qrcode");
    var newSearch = urlParams.toString();
    var newUrl = "".concat(location.pathname).concat(newSearch ? "?".concat(newSearch) : "");
    history.replace(newUrl);
  }
};
export var removeQrcodeFromStorage = () => {
  storage.removeItem(QRCODE_STORAGE_KEY);
};
export var usePartnershipQrcode = _ref => {
  var {
    isSignedIn,
    currentUser,
    getUserDetails
  } = _ref;
  var history = useHistory();
  var location = useLocation();
  var hasProcessed = useRef(false);
  var fetchUserDetails = useAwaitQuery(GET_CUSTOMER);
  var [createOrUpdatePartnershipQrcode] = useMutation(CREATE_OR_UPDATE_MEMBER_PARTNERSHIP_QRCODE, {
    fetchPolicy: "no-cache"
  });
  useEffect(() => {
    if (hasProcessed.current) return;
    var urlParams = new URLSearchParams(location.search);
    var qrcodeFromUrl = urlParams.get("qrcode");
    var qrcodeFromStorage = storage.getItem(QRCODE_STORAGE_KEY);
    var qrcode = qrcodeFromUrl || qrcodeFromStorage;
    if (!qrcode) return;
    if (!isSignedIn) {
      if (qrcodeFromUrl) {
        storage.setItem(QRCODE_STORAGE_KEY, qrcode, QRCODE_TTL);
        cleanupQrcodeFromUrl(history, location);
      }
      return;
    }
    if (!(currentUser !== null && currentUser !== void 0 && currentUser.email)) return;
    hasProcessed.current = true;
    var processQrcode = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          yield createOrUpdatePartnershipQrcode({
            variables: {
              qrcode
            }
          });
          if (getUserDetails) {
            yield getUserDetails({
              fetchUserDetails
            });
          }
          cleanupQrcodeFromUrl(history, location);
          removeQrcodeFromStorage();
        } catch (error) {
          console.error("Error processing partnership QR code:", error);
          cleanupQrcodeFromUrl(history, location);
          removeQrcodeFromStorage();
        }
      });
      return function processQrcode() {
        return _ref2.apply(this, arguments);
      };
    }();
    processQrcode();
  }, [isSignedIn, currentUser === null || currentUser === void 0 ? void 0 : currentUser.email, location.search]);
  return null;
};